import { defineMessages } from 'react-intl';

export default defineMessages({
  emailInputLabel: {
    id: 'ResetPasswordModal.emailInputLabel',
    description: 'Email Input Label',
    defaultMessage: 'Please enter your email address below. You will receive a link to reset your password.',
  },

  customerCareHelp: {
    id: 'ResetPasswordModal.customerCareHelp',
    description: 'Customer care Help',
    defaultMessage: 'Need more help?',
  },
  customerCareHelpText: {
    id: 'ResetPasswordModal.customerCareHelpText',
    description: 'Customer care Help text',
    defaultMessage: 'If youre still having difficulty logging into your account, please call our customer service representatives at',
  },
  backBtn: {
    id: 'ResetPasswordModal.back',
    description: 'Login modal back button',
    defaultMessage: 'Back',
  },
  resetPasswordModalTitle: {
    id: 'ResetPasswordModal.title1',
    description: 'Reset Password modal title 1',
    defaultMessage: 'Reset Your Password',
  },
});
